module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/2023/about-65479cd2242eaacd5546eb41fa570a9f.svg&quot;;"